import { createStore } from 'satcheljs';
var initialHeaderViewState = {
    activeCharm: null,
};
export var getStore = createStore('headerViewState', initialHeaderViewState);
//# sourceMappingURL=store.js.map